module.exports = __webpack_public_path__ + "static/media/HDJN02.5cb8a190.jpg";